import {  Layout, Row, Col,ConfigProvider,Card } from 'antd';
import React, { Component } from "react";
import es_ES from 'antd/lib/locale/es_ES';
import Foot from "../components/Footer"
import JuryMenu from "../components/JuryMenu"
import {IP} from '../components/utils';

class JuryBases extends Component {
  async componentDidMount() {
    const response = await fetch(IP + 'api/casa/genero/');
    const json = await response.json();
    if(json['detail']){
      localStorage.clear()
      window.location.reload(); 
    }
  }
  render() {
    const {  Content } = Layout;
    return (
      <div className="page-container">
        <div className = "content-wrap">
          <ConfigProvider locale={es_ES}>
          <Layout style={{backgroundColor:'white'}}>
            <JuryMenu/>
            <div style={{flexDirection:'column', flex:'1 0 auto', display:'flex'}} >
              <Row >
                <Col span={24} >
                  <Content style={{ padding: '0 50px' }}>
                    <Card title=" Bases Premio Literario Casa de las Américas " bordered={false}  >
                      <p>
                        La Casa de las Américas convoca para el año 2022 a la edición 62 de su Premio Literario. En esta ocasión podrán concursar obras inéditas en los géneros de <b> novela, poesía y ensayo de tema histórico-social. </b>
                        Los autores concursantes deberán regirse por las siguientes bases:
                        <ol style={{paddingLeft:'1.8em'}}>
                          <li>Podrán concursar obras inéditas en español en los siguientes géneros: <b>novela, poesía y ensayo de tema histórico-social</b>. Se considerarán inéditas aun aquellas que hayan sido impresas en no más de la mitad.</li>
                          <li>En <b>novela</b> y <b>poesía</b> solo podrán participar autores latinoamericanos, naturales o naturalizados. </li>
                          <li>Por el premio de <b>ensayo de tema histórico-social</b> podrán concursar también autores de cualquier otra procedencia, con un libro sobre la América Latina o el Caribe, escrito en español. </li>
                          <li>Ningún autor podrá enviar más de un libro por género, ni participar con una obra en proceso de impresión, aunque esté inédita, o que haya obtenido algún premio nacional o internacional u opte por él mientras no se haya dado el fallo del Premio Casa de las Américas. Tampoco podrá participar en un género en el que hubiera obtenido ya este Premio, en alguno de los cuatro años anteriores.</li>
                          <li>Se otorgará un premio único e indivisible por cada género que consistirá en 3000 dólares o su equivalente en la moneda nacional que corresponda, y la publicación de la obra por la Casa de las Américas. Se otorgarán menciones si el jurado las estima necesarias, sin que ello implique retribución ni compromiso editorial por parte de la Casa de las Américas.</li>
                          <li>Las obras serán firmadas con seudónimo. </li>
                          <li>La Casa de las Américas se reserva el derecho de publicación de la que será considerada primera edición de las obras premiadas, hasta un máximo de 10 000 ejemplares, aunque se trate de una coedición o de reimpresiones coeditadas. Tal derecho incluye no solo evidentes aspectos económicos sino todas las características gráficas y otras de la mencionada primera edición. Asimismo, la Casa de las Américas, de común acuerdo con los autores, promoverá la circulación en formato digital de los libros premiados.</li>
                          <li>Los autores deberán enviar sus obras de manera digital, en pdf, accediendo a la plataforma<a  target="_blank" href="https://premiocasa.cu">https://premiocasa.cu</a>. Las obras no excederán en ningún caso de las quinientas (500) páginas.</li>
                          <li>El plazo de admisión cerrará el 31 de octubre de 2021 a las 12 de la noche, hora de La Habana. </li>
                          <li>  Los premios se darán a conocer 28 de enero de 2022.</li>
                          <li>El incumplimiento de alguna de estas bases conduciría a la invalidación del Premio otorgado.</li>
                        </ol> 
                      </p>
                    </Card>
                  </Content>
                </Col>
              </Row>
            </div>
          </Layout>
        </ConfigProvider>
      </div>
      <div >
        <Foot jury={true}/>
      </div>
    </div>
    );
  }
}
export default JuryBases;


